import { apiRequest } from './http-client';

export interface AvailityVobEntity {
  activePolicy?: boolean;
  message?: string;
  [key: string]: unknown;
}

export async function runAvailityVob(
  apiBase: string,
  authToken: string,
  patientId: number,
  facilityId: number
): Promise<AvailityVobEntity> {
  const response = await apiRequest<AvailityVobEntity>(
    apiBase,
    `/availity/vob?patientId=${patientId}&facilityId=${facilityId}`,
    { authToken }
  );

  if (response.hasErrors) {
    const message =
      typeof response.entity === 'object' &&
      response.entity !== null &&
      'message' in response.entity &&
      typeof (response.entity as { message: unknown }).message === 'string'
        ? (response.entity as { message: string }).message
        : response.errorMessage ?? 'Availity VOB failed';
    throw new Error(message);
  }

  return response.entity ?? {};
}

export function getAvailityErrorMessage(entity: AvailityVobEntity): string {
  if (typeof entity.message === 'string' && entity.message.trim()) {
    return entity.message;
  }
  return 'An error occurred while running Availity VOB.';
}
